// Google Tag Manager — ładowany WYŁĄCZNIE po zgodzie na cookies analityczne (baner CookieConsent).
// Bez zgody żaden skrypt Google nie jest pobierany. Google Analytics 4 (G-Q6TBRW68FL) jest skonfigurowany
// w kontenerze GTM, nie w kodzie strony.
export const GTM_ID = process.env.REACT_APP_GTM_ID || "GTM-MNG45N8X";

const CONSENT_KEY = "nexxsite-cookie-consent"; // "granted" | "denied"; zapamiętana decyzja to zapis niezbędny
export const CONSENT_EVENT = "nexxsite:consent";
export const OPEN_CONSENT_EVENT = "nexxsite:open-consent";

let loaded = false;

export function getConsent() {
  try {
    const value = window.localStorage.getItem(CONSENT_KEY);
    return value === "granted" || value === "denied" ? value : null;
  } catch {
    return null;
  }
}

export function setConsent(value) {
  try { window.localStorage.setItem(CONSENT_KEY, value); } catch { /* prywatne okno: decyzja tylko na tę wizytę */ }
  if (value === "granted") loadAnalytics();
  else revokeAnalytics();
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }));
}

// Polecenia Consent Mode muszą trafić do dataLayer jako obiekt `arguments` (tak jak robi to gtag()).
function consentCommand() {
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

/** Wstrzykuje kontener GTM (raz) i przekazuje do dataLayer zdarzenia konwersji ze strony. */
export function loadAnalytics() {
  if (loaded || typeof window === "undefined" || !GTM_ID) return;
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  // Baner pyta tylko o analitykę: zgody reklamowe zostają odrzucone.
  consentCommand("consent", "default", { ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied", analytics_storage: "granted" });
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(GTM_ID)}`;
  document.head.appendChild(script);
  window.addEventListener("nexxsite:conversion", onConversion);
}

function onConversion(event) {
  const { event: name, services = [] } = event.detail || {};
  if (!name) return;
  // conversionEvents.js nie przekazuje danych formularza ani kontaktowych — tylko nazwę zdarzenia i usługi.
  window.dataLayer.push({ event: name, services: services.join(",") });
}

/** Wycofanie zgody: tagi Google przestają zapisywać cookies, a istniejące cookies _ga są usuwane. */
function revokeAnalytics() {
  if (loaded) consentCommand("consent", "update", { analytics_storage: "denied" });
  window.removeEventListener("nexxsite:conversion", onConversion);
  const host = window.location.hostname.replace(/^www\./, "");
  for (const cookie of document.cookie.split(";")) {
    const name = cookie.split("=")[0].trim();
    if (!name.startsWith("_ga")) continue;
    for (const domain of ["", `; domain=${host}`, `; domain=.${host}`]) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domain}`;
    }
  }
}
